module.exports = __webpack_public_path__ + "img/156.287ae57b.jpg";